import React from 'react'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'

interface Props {
  title?: string
  fullScreen?: boolean
  style?: React.CSSProperties | undefined
  children?: React.ReactNode
}
const Card = ({ title, style, fullScreen, children }: Props) => {
  const classes = useStyles()

  return (
    <Paper style={style} className={fullScreen ? classes.fullScreenCard : classes.card}>
      {title && (
        <Typography className={fullScreen ? classes.fullScreenTitle : classes.title}>
          {title}
        </Typography>
      )}
      {children}
    </Paper>
  )
}

export default Card
